import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auth0Client, LogoutOptions } from '@auth0/auth0-spa-js';

import { ApiService } from '@shared/services/api.service';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable()
export class MojoAuthorizationService extends ApiService<any> {
  constructor(http: HttpClient) {
    super(http);
  }

  public logout(auth0: Auth0Client, AUTH0_LOGOUT_URL: string) {
    super
      .patch({ url: 'logout' })
      .pipe(first())
      .subscribe(
        () => this.logoutFromAuth0(auth0, AUTH0_LOGOUT_URL),
        () => this.logoutFromAuth0(auth0, AUTH0_LOGOUT_URL),
      );
  }

  public logoutFromAuth0(auth0: Auth0Client, AUTH0_LOGOUT_URL: string) {
    auth0.logout({
      logoutParams: { returnTo: AUTH0_LOGOUT_URL, federated: true },
    } as LogoutOptions);
  }

  public getBrowserIdCookie() {
    super
      .get({ url: 'get-browser-id' })
      .pipe(first())
      .subscribe(
        () => console.log('BrowserId cookie set'),
        (err) => console.error('failed while getting browser id', err),
      );
  }

  public getLoginTime(): Observable<any> {
    return super.get({ url: 'users/last-login' }).pipe(first());
  }
}
